import React from "react";
import { Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import { BsFacebook, BsLinkedin } from "react-icons/bs";
import { motion } from "framer-motion";
import { SiFiverr } from "react-icons/si";

const Footer = () => {
  const handleLinkClick = () => {
    scroll.scrollToTop();
  };

  const logo = `${process.env.PUBLIC_URL}/assets/Logo.webp`;

  return (
    <footer className="poppins bg-white">
      <div className="pt-16 md:pt-28 relative grid grid-cols-1 gap-y-6 lg:grid-cols-4 md:grid-cols-2 mx-auto md:px-6 p-5 lg:gap-x-20">
        {/* Logo & Description */}
        <div className="mt-[-20px]">
          <Link to="/" onClick={handleLinkClick}>
            <img
              className="h-[64.5px] w-[130.7px] md:w-auto md:h-24 md:ml-0 ml-[-14px]"
              src={logo}
              alt="MbaSolutions"
            />
          </Link>
          <p className="text-gray-500 md:ml-6 mt-3 text-sm md:text-base">
            Unlocking Potential, Achieve Excellence through Our ISO-Certified
            Standards and Empower Your Success Journey
          </p>
        </div>

        {/* Information */}
        <div className="mb-6">
          <h2 className="font-bold text-[18px] uppercase text-black drop-shadow-sm">
            Information
          </h2>
          <div className="pt-4 w-20 border-b-4 border-[var(--bg-primary)]"></div>
          <ul className="pt-5 text-gray-500 space-y-2">
            {[
              { text: "Contact Us", link: "/contact" },
              { text: "About Us", link: "/about" },
              { text: "Our Team", link: "/team" },
              { text: "Careers", link: "/careers" },
              { text: "Terms & Conditions", link: "/terms" },
            ].map((item, idx) => (
              <motion.li
                key={idx}
                className="cursor-pointer text-sm md:text-base"
                whileHover={{ x: 4, color: "var(--bg-primary)" }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <Link to={item.link} onClick={handleLinkClick}>
                  {item.text}
                </Link>
              </motion.li>
            ))}
          </ul>
        </div>

        {/* Pages */}
        <div className="mb-6">
          <h2 className="font-bold text-[18px] uppercase text-black drop-shadow-sm">
            Pages
          </h2>
          <div className="pt-4 w-20 border-b-4 border-[var(--bg-primary)]"></div>
          <ul className="pt-5 text-gray-500 space-y-2">
            {[
              { text: "Services", link: "/services" },
              { text: "Tracking", link: "/tracking" },
              { text: "Blogs", link: "/blog" },
              { text: "Toolkits", link: "/toolkits" },
            ].map((item, idx) => (
              <motion.li
                key={idx}
                className="cursor-pointer text-sm md:text-base"
                whileHover={{ x: 4, color: "var(--bg-primary)" }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <Link to={item.link} onClick={handleLinkClick}>
                  {item.text}
                </Link>
              </motion.li>
            ))}
          </ul>
        </div>

        {/* Follow Us */}
        <div>
          <h2 className="font-bold text-[18px] uppercase text-black drop-shadow-sm">
            Follow us
          </h2>
          <div className="pt-4 w-20 border-b-4 border-[var(--bg-primary)]"></div>
          <div className="flex pt-5 items-center md:justify-start space-x-4">
            {[
              {
                icon: <BsFacebook size={18} />,
                link: "https://www.facebook.com/MBA.Solutions.Official",
              },
              {
                icon: <BsLinkedin size={18} />,
                link: "https://www.linkedin.com/company/64721224/admin/feed/posts/",
              },
              {
                icon: <SiFiverr size={18} />,
                link: "https://www.fiverr.com/users/mba_solutions1/seller_dashboard",
              }, // Fiverr icon
            ].map((item, idx) => (
              <motion.a
                key={idx}
                href={item.link}
                target="_blank"
                rel="noreferrer"
                whileHover={{
                  scale: 1.15,
                  backgroundColor: "#ffffff",
                  color: "var(--bg-primary)",
                }}
                transition={{ type: "spring", stiffness: 300 }}
                className={`p-2 rounded-full bg-[var(--bg-primary)] text-white font-bold flex items-center justify-center`}
              >
                {item.icon}
              </motion.a>
            ))}
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="text-[16px] text-center text-gray-400 bg-white md:px-7 p-4">
        © {new Date().getFullYear()}{" "}
        <span className="text-black">
          All Rights Reserved by MBA Solutions Pvt.Ltd.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
